import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { RouterLink } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { CurrentSubscriptionService } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { StaticImageUrlPipe } from '@rma/generic/util/pipes/static-image-url';
import { NavigationHeaderComponent } from '@rma/layout/public/navigation-header';
import { Observable } from 'rxjs';

@Component({
  selector: 'rma-unsubscribe-support',
  imports: [TranslocoModule, MatCardModule, MatButtonModule, RouterLink, StaticImageUrlPipe, NavigationHeaderComponent],
  templateUrl: './unsubscribe-support.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnsubscribeSupportComponent {
  public unsubscribeUrl$: Observable<string>;

  constructor(private readonly currentSubscriptionService: CurrentSubscriptionService) {
    this.unsubscribeUrl$ = this.currentSubscriptionService.unsubscribeUrl$;
  }
}
